import React from 'react'

export default ({
  attribute
}) => {
  if (attribute.value) {
    return (
      <div className='dropzone-preview'>
        <button className='close' onClick={(e) => handleClose(attribute, e)} />

        <img src={attribute.value.preview} />
        <p>{attribute.value.name}</p>
      </div>
    )
  }

  return (
    <div className='dropzone-preview'>
      <p><strong>Browse</strong> your computer or drag and drop your image here</p>
    </div>
  )
}

function handleClose (attribute, event) {
  event.stopPropagation()
  event.preventDefault()

  attribute.onChange(null)
}



// WEBPACK FOOTER //
// ./src/components/forms/dropzone-preview.js